import { render } from "./passchange-form.vue?vue&type=template&id=1ccab025"
import script from "./passchange-form.vue?vue&type=script&lang=js"
export * from "./passchange-form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__